import { NotificationLevel } from '../../enums/notification-level.enum';


export class Notification {
  constructor(
    public message: string,
    public level: NotificationLevel = NotificationLevel.Info,
    public timeoutMs: number = 3000) { }
}
